import React from 'react';
import { StyledApp } from './App.styled';
import Header from './Header/Header';
import Main from './Main/Main';

const App = () => (
  <StyledApp>
    <Header />
    <Main />
  </StyledApp>
);

export default App;
